import React from 'react';
import WorkspaceRow from './WorkspaceRow';

const WorkspacesTableRows = ({
  className,
  columns,
  items,
  onCheckBoxClick,
  selectable,
}) => (
  items.map((item, index) => (
    <WorkspaceRow
      className={className}
      key={`workspaces_table_row_${item.uuid}`}
      workspace={item}
      onCheckBoxClick={onCheckBoxClick}
      columns={columns}
      selectable={selectable}
      upward={index > 4}
    />
  ))
);

export default WorkspacesTableRows;
